import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { Loader2 } from 'lucide-react';

interface DeliveryStatusBadgeProps {
  status: string | null;
  isLoading?: boolean;
  className?: string;
}

export function DeliveryStatusBadge({ status, isLoading, className }: DeliveryStatusBadgeProps) {
  const { t } = useTranslation('shippings');

  if (isLoading) {
    return (
      <Badge variant="outline" className={`bg-gray-50 text-gray-500 ${className || ''}`}>
        <Loader2 className="h-3 w-3 mr-1 animate-spin" />
        {t('delivery.loading', 'Loading...')}
      </Badge>
    );
  }

  if (!status) {
    return (
      <Badge variant="outline" className={`bg-gray-50 text-gray-400 ${className || ''}`}>
        -
      </Badge>
    );
  }

  // Determine color based on status text
  const lowerStatus = status.toLowerCase();
  let colorClass = 'bg-gray-100 text-gray-800';

  if (lowerStatus.includes('delivered') || lowerStatus.includes('livr')) {
    colorClass = 'bg-green-100 text-green-800';
  } else if (lowerStatus.includes('transit') || lowerStatus.includes('en route')) {
    colorClass = 'bg-blue-100 text-blue-800';
  } else if (lowerStatus.includes('out for delivery') || lowerStatus.includes('livraison')) {
    colorClass = 'bg-yellow-100 text-yellow-800';
  } else if (lowerStatus.includes('exception') || lowerStatus.includes('delay')) {
    colorClass = 'bg-red-100 text-red-800';
  }

  return (
    <Badge variant="outline" className={`${colorClass} ${className || ''}`}>
      {status}
    </Badge>
  );
}
